/* istanbul ignore file */
import { createAction, createReducer } from '@reduxjs/toolkit';
import { USUARIO_LOGADO_FAS } from 'utils/consts';

const INITIAL_STATE = {
  todosAtendentes: { list: [] },
  atendenteDetalhar: null,
  atendenteLogado: JSON.parse(sessionStorage.getItem(USUARIO_LOGADO_FAS)) || null,
};
export const duckTodosAtendentes = createAction('DUCK_TODOS_ATENDENTES');
export const duckAtendenteDetalhar = createAction('DUCK_DADOS_ATENDENTE_DETALHAR');
export const duckAtendenteLogado = createAction('DUCK_DADOS_ATENDENTE_LOGADO');

export default createReducer(INITIAL_STATE, {
  [duckTodosAtendentes.type]: (state, action) => ({
    ...state,
    todosAtendentes: action.payload,
  }),
  [duckAtendenteDetalhar.type]: (state, action) => ({
    ...state,
    atendenteDetalhar: action.payload,
  }),
  [duckAtendenteLogado.type]: (state, action) => ({
    ...state,
    atendenteLogado: action.payload,
  }),
});
